import { createSlice } from "@reduxjs/toolkit";
import {
  addApiCases,
  createDynamicThunk,
} from "../../../../../service/requestHandler";

export const treeMapAccOpenApi = createDynamicThunk(
  "treeMapAccOpenApi",
  "/report/api/v1/regulatoryCompliance/trmgTreeMap",
  ["packName"]
);

export const treeMapComplianceDrillDown = createDynamicThunk(
  "treeMapComplianceDrillDown",
  "/report/api/v1/conformancePack/TRMG/getComplianceListByRuleForTRMG",
  ["pageNumber", "itemsPerPage"]
);


export const treeMapNonComplianceDrillDown = createDynamicThunk(
  "treeMapNonComplianceDrillDown",
  "/report/api/v1/conformancePack/TRMG/getNonCompliantListByRuleForTRMG",
  ["pageNumber", "itemsPerPage"]
);


export const treeMapNotApplicableDrillDown = createDynamicThunk(
  "treeMapNotApplicableDrillDown",
  "/report/api/v1/conformancePack/TRMG/getNotApplicableListByRuleForTRMG",
  ["pageNumber", "itemsPerPage"]
);


export const treeMapExceptionDrillDown = createDynamicThunk(
  "treeMapExceptionDrillDown",
  "/report/api/v1/conformancePack/TRMG/getExceptionListByRuleForTRMG",
  ["pageNumber", "itemsPerPage"]
);

export const manageComplianceApi = createDynamicThunk(
  "manageComplianceApi",
  "/report/api/v1/regulatoryCompliance/drillDownTreeMap/manageCompliance",
  ["packName"]
);

export const submitManageCompliance = createDynamicThunk(
  "submitManageCompliance",
  "/aws/api/v1/regulatoryCompliance/manageComplianceForRegulatoryFindings",
);

export const chartDataApi = createDynamicThunk(
  "chartDataApi",
  "/report/api/v1/conformancePack/TRMG/GraphData",
  ["packName"]
);

// New unified drilldown API for all compliance types
export const regulatoryFindingsDrilldownTRMG = createDynamicThunk(
  "regulatoryFindingsDrilldownTRMG",
  "/report/api/v1/regulatoryCompliance/getListForRegulatoryFindings",
  ["pageNumber", "itemsPerPage"]
);

// Resource count drilldown API
export const resourceIdDrilldownTRMG = createDynamicThunk(
  "resourceIdDrilldownTRMG",
  "/report/api/v1/regulatoryCompliance/getResourceIdDrillDownDetails",
  ["policy", "pageNumber", "itemsPerPage"]
);

export const initialState = {
  treeMapAccOpenApiData: [],
  treeMapAccOpenApiDataLoading: false,
  treeMapAccOpenApiError: null,
  treeMapComplianceDrillDownData: [],
  treeMapComplianceDrillDownLoading: false,
  treeMapNonComplianceDrillDownData: [],
  treeMapNonComplianceDrillDownLoading: false,
  treeMapNotApplicableDrillDownData: [],
  treeMapNotApplicableDrillDownLoading: false,
  treeMapExceptionDrillDownData: [],
  treeMapExceptionDrillDownLoading: false,
  manageComplianceApiData: {},
  manageComplianceApiLoading: false,
  submitManageComplianceData: {},
  submitManageComplianceLoading: false,
  chartDataApiData: [],
  chartDataApiDataLoading: false,
  regulatoryFindingsDrilldownData: [],
  regulatoryFindingsDrilldownLoading: false,
  resourceIdDrilldownData: [],
  resourceIdDrilldownLoading: false,
};

export const TRMGSlice = createSlice({
  name: "TRMGSlice",
  initialState,
  reducers: {
    resetTRMGSlice: () => initialState,
    resetTRMGData: () => initialState,
    resetdrillDownData: (state) => {
      state.treeMapComplianceDrillDownData = [];
      state.treeMapNonComplianceDrillDownData = [];
      state.treeMapNotApplicableDrillDownData = [];
      state.treeMapExceptionDrillDownData = [];
    },
  },
  extraReducers: (builder) => {
    // treeMapAccOpenApi handled manually so we can track API errors separately
    builder
      .addCase(treeMapAccOpenApi.pending, (state) => {
        state.treeMapAccOpenApiDataLoading = true;
        state.treeMapAccOpenApiError = null;
      })
      .addCase(treeMapAccOpenApi.fulfilled, (state, action) => {
        state.treeMapAccOpenApiDataLoading = false;
        state.treeMapAccOpenApiData = Array.isArray(action.payload) ? action.payload : [];
        state.treeMapAccOpenApiError = null;
      })
      .addCase(treeMapAccOpenApi.rejected, (state, action) => {
        state.treeMapAccOpenApiDataLoading = false;
        state.treeMapAccOpenApiData = [];
        state.treeMapAccOpenApiError =
          action.error?.message || "Failed to load compliance data. Please try again.";
      });
    addApiCases(
      builder,
      treeMapComplianceDrillDown,
      "treeMapComplianceDrillDownData"
    );
    addApiCases(
      builder,
      treeMapNonComplianceDrillDown,
      "treeMapNonComplianceDrillDownData"
    );
    addApiCases(
      builder,
      treeMapNotApplicableDrillDown,
      "treeMapNotApplicableDrillDownData"
    );
    addApiCases(builder, treeMapExceptionDrillDown, "treeMapExceptionDrillDownData");
    addApiCases(builder, manageComplianceApi, "manageComplianceApiData");
    addApiCases(builder, submitManageCompliance, "submitManageComplianceData");
    addApiCases(builder, chartDataApi, "chartDataApiData");
    addApiCases(builder, regulatoryFindingsDrilldownTRMG, "regulatoryFindingsDrilldownData");
    addApiCases(builder, resourceIdDrilldownTRMG, "resourceIdDrilldownData");
  },
});

export const { resetTRMGSlice, resetTRMGData, resetdrillDownData } =
  TRMGSlice.actions;
export default TRMGSlice.reducer;
